import axios from "axios";
import qs from "qs";

export enum FeedbackType {
    Bug = 1, // 平台缺陷
    Suggestion = 2, // 功能建议
    Requirement = 3 // 新需求
}

export interface FeedbackData {
    type: FeedbackType;
    value: string; // 建议内容
    pic: string[];
    nickname: string;
    phone: string;
    mail: string;
}

/**
 * 保存用户反馈
 * @param data
 */
export function saveFeedback(data: FeedbackData) {
    return axios.post(
        "/student/feedback/save",
        qs.stringify({ ...data, pic: data.pic?.join(",") })
    );
}
